/* eslint-disable no-unused-vars */
export enum defaultColumnWidths {
  //note that columns that have both checkbox and expand arrow will add these 2 widths together
  checkbox = 40,
  expandArrow = 13,
  esid = 130,
  status = 110, // status,
  latestActivity = 125,
  mainAction = 150,
  quoteField = 150, // bid, ask, mid
  indicativeMid = 130,
  provider = 80,
  type = 95,
  structureType = 130,
  details = 400,
  actionedInfo = 140, //actionedAt, actionedBy, owner, dateCreated
  currency = 100,
  extStructureId = 110,
  name = 365, //security
  portfolioName = 180,
  portfolio = 100,
  side = 115, //direction - Max size needed at 115 for PR allocations table.
  nominal = 90, //number values, including nominal, dealtStrike, notional,
  quotedSize = 100,
  percentQuoted = 90,
  percentIceberg = 90,
  complianceStatus = 125,
  date = 130, //also includes validUntil
  expiry = 170, //expiryEnd - fits "12-Aug-2026 09:00" plus the OP's edit pencil
  dv01 = 80,
  order = 30,
  feeAdjustedQuote = 110, //dealt price
  dealtRepoRate = 120, // Wont get used anymore - will use above.
  cpi = 95,
  cpiIndex = 80,
  newIssue = 90,
  book = 150,
  referenceRate = 80,
  isin = 150,
  country = 125,
  issuer = 80,
  unwind = 100,
  strike = 100,

  transactionType = 130,
  npv = 30,
  recoupon = 60,
  coupon = 105,
  indicativeNPV = 110,
  referenceIndex = 140,
  quotedMargin = 120,
  currentCoupon = 130,
  dealer = 140,
  cash = 150,
  indicativeCash = 190,
  executionFee = 90,
  dealtFee = 110,

  // ---------------------------
  //-----currently undefined-----
  level = 100,
  refPrice = 100,
  filledPercent = 100,
  refAsset = 100,
  minClip = 100,
  fillQuantity = 120,
  fillPrice = 120,
  leg = 100,

  // --- ORDER --- //
  referencePrice = 120,
  referenceSpread = 120,
  referenceAsset = 120,
  filledAt = 150,
}
